import { render, staticRenderFns } from "./QuizInfoView.vue?vue&type=template&id=19079cf0&"
import script from "./QuizInfoView.vue?vue&type=script&lang=js&"
export * from "./QuizInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports